import React, {ReactNode} from 'react';
import Notifications from 'shared/components/notifications';
import ConnectedHeader from 'shared/student/registration/containers/connected-header';
import ImpostorToolbar from 'shared/components/impostor-toolbar';
import AppLayout from 'src/components/app-layout';

interface Props {
  children: ReactNode;
}

const Container = ({children}: Props) => (
  <>
    <AppLayout
      topToolbars={
        <>
          <ImpostorToolbar />
          <ConnectedHeader />
        </>
      }
    >
      <Notifications />
      <div className="registration">{children}</div>
    </AppLayout>
  </>
);

export default Container;
